import {NgModule} from '@angular/core';
import {EA_ENTITY_PROVIDER} from "./ea.entity-provider";
import {CoreModule} from "../../core/core.module";
import {EaOverviewPage} from "./page/ea-overview-page/ea-overview.page";
import {EaDashboardPage} from "./page/overview/ea-dashboard/ea-dashboard.page";
import {EaProjectPage} from "./page/object/ea-project/ea-project.page";
import {EaAnalysisPage} from "./page/overview/ea-analysis/ea-analysis.page";
import {EaConfigPage} from "./page/overview/ea-config/ea-config.page";
import {EaProjectCreatePage} from "./page/guided-create/ea-project-create.page";
import {
    EaProjectObjectComponent
} from "./component/object-components/ea-project-object-component/ea-project-object.component";
import {
    EaAnalysisObjectComponent
} from "./component/object-components/ea-analysis-object-component/ea-analysis-object.component";
import {
    EaModelDraftObjectComponent
} from "./component/object-components/ea-model-draft-object-component/ea-model-draft-object.component";
import {
    EaImportConfigObjectComponent
} from "./component/object-components/ea-import-config-object-component/ea-import-config-object.component";
import {
    EaProjectListWidgetComponent
} from "./component/widgets/ea-project-list-widget/ea-project-list-widget.component";
import {EaFileUploadWidgetComponent} from "./component/widgets/ea-file-upload-widget/ea-file-upload-widget.component";
import {
    EaFilePreviewWidgetComponent
} from "./component/widgets/ea-file-preview-widget/ea-file-preview-widget.component";
import {
    EaColumnAnalysisWidgetComponent
} from "./component/widgets/ea-column-analysis-widget/ea-column-analysis-widget.component";
import {
    EaColumnDetailWidgetComponent
} from "./component/widgets/ea-column-detail-widget/ea-column-detail-widget.component";
import {EaValueListWidgetComponent} from "./component/widgets/ea-value-list-widget/ea-value-list-widget.component";
import {
    EaQualityScoreWidgetComponent
} from "./component/widgets/ea-quality-score-widget/ea-quality-score-widget.component";
import {
    EaModelDraftFieldListWidgetComponent
} from "./component/widgets/ea-model-draft-field-list-widget/ea-model-draft-field-list-widget.component";
import {
    EaModelDraftFieldEditorWidgetComponent
} from "./component/widgets/ea-model-draft-field-editor-widget/ea-model-draft-field-editor-widget.component";
import {
    EaImportFieldMappingWidgetComponent
} from "./component/widgets/ea-import-field-mapping-widget/ea-import-field-mapping-widget.component";
import {
    EaImportPreviewWidgetComponent
} from "./component/widgets/ea-import-preview-widget/ea-import-preview-widget.component";
// Guided Create Components
import {
    EaProjectGuidedCreateComponent
} from "./component/guided-create/ea-project-guided-create/ea-project-guided-create.component";
import {EaStepBaseComponent} from "./component/guided-create/steps/ea-step-base.component";
import {
    EaStepProjectInfoComponent
} from "./component/guided-create/steps/ea-step-project-info/ea-step-project-info.component";
import {
    EaStepFileUploadComponent
} from "./component/guided-create/steps/ea-step-file-upload/ea-step-file-upload.component";
import {EaStepAnalysisComponent} from "./component/guided-create/steps/ea-step-analysis/ea-step-analysis.component";
import {
    EaStepModelDraftComponent
} from "./component/guided-create/steps/ea-step-model-draft/ea-step-model-draft.component";
import {
    EaStepImportConfigComponent
} from "./component/guided-create/steps/ea-step-import-config/ea-step-import-config.component";
// Tab Components
import {
    EaProjectOverviewTabComponent
} from "./component/object-components/ea-project-object-component/tabs/ea-project-overview-tab/ea-project-overview-tab.component";
import {
    EaProjectSourceFilesTabComponent
} from "./component/object-components/ea-project-object-component/tabs/ea-project-source-files-tab/ea-project-source-files-tab.component";
import {
    EaProjectAnalysisTabComponent
} from "./component/object-components/ea-project-object-component/tabs/ea-project-analysis-tab/ea-project-analysis-tab.component";
import {
    EaProjectModelDraftsTabComponent
} from "./component/object-components/ea-project-object-component/tabs/ea-project-model-drafts-tab/ea-project-model-drafts-tab.component";
import {
    EaProjectImportConfigsTabComponent
} from "./component/object-components/ea-project-object-component/tabs/ea-project-import-configs-tab/ea-project-import-configs-tab.component";


@NgModule({
    declarations: [
        // Pages
        EaOverviewPage,
        EaDashboardPage,
        EaProjectPage,
        EaAnalysisPage,
        EaConfigPage,
        EaProjectCreatePage,
        // Object Components
        EaProjectObjectComponent,
        EaAnalysisObjectComponent,
        EaModelDraftObjectComponent,
        EaImportConfigObjectComponent,
        // Widgets
        EaProjectListWidgetComponent,
        EaFileUploadWidgetComponent,
        EaFilePreviewWidgetComponent,
        EaColumnAnalysisWidgetComponent,
        EaColumnDetailWidgetComponent,
        EaValueListWidgetComponent,
        EaQualityScoreWidgetComponent,
        EaModelDraftFieldListWidgetComponent,
        EaModelDraftFieldEditorWidgetComponent,
        EaImportFieldMappingWidgetComponent,
        EaImportPreviewWidgetComponent,
        // Guided Create Components
        EaProjectGuidedCreateComponent,
        EaStepBaseComponent,
        EaStepProjectInfoComponent,
        EaStepFileUploadComponent,
        EaStepAnalysisComponent,
        EaStepModelDraftComponent,
        EaStepImportConfigComponent,
        // Tab Components
        EaProjectOverviewTabComponent,
        EaProjectSourceFilesTabComponent,
        EaProjectAnalysisTabComponent,
        EaProjectModelDraftsTabComponent,
        EaProjectImportConfigsTabComponent,
    ],
    exports: [
        // Pages
        EaOverviewPage,
        EaDashboardPage,
        EaProjectPage,
        EaAnalysisPage,
        EaConfigPage,
        EaProjectCreatePage,
        // Object Components
        EaProjectObjectComponent,
        EaAnalysisObjectComponent,
        EaModelDraftObjectComponent,
        EaImportConfigObjectComponent,
        // Widgets
        EaProjectListWidgetComponent,
        EaFileUploadWidgetComponent,
        EaFilePreviewWidgetComponent,
        EaColumnAnalysisWidgetComponent,
        EaColumnDetailWidgetComponent,
        EaValueListWidgetComponent,
        EaQualityScoreWidgetComponent,
        EaModelDraftFieldListWidgetComponent,
        EaModelDraftFieldEditorWidgetComponent,
        EaImportFieldMappingWidgetComponent,
        EaImportPreviewWidgetComponent,
        // Guided Create Components
        EaProjectGuidedCreateComponent,
        EaStepBaseComponent,
        EaStepProjectInfoComponent,
        EaStepFileUploadComponent,
        EaStepAnalysisComponent,
        EaStepModelDraftComponent,
        EaStepImportConfigComponent,
        // Tab Components
        EaProjectOverviewTabComponent,
        EaProjectSourceFilesTabComponent,
        EaProjectAnalysisTabComponent,
        EaProjectModelDraftsTabComponent,
        EaProjectImportConfigsTabComponent,
    ],
    imports: [
        CoreModule,
    ],
    providers: [EA_ENTITY_PROVIDER]
})
export class EaModule {
}
